module.exports = __webpack_public_path__ + "static/media/check@2x.fc956d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/thanks/check@2x.png
// module id = 107
// module chunks = 0